import React from "react";

const icon = `${EASYCOMMERCE.assets}admin/img/nofound/no-customer.png`;

const EmptyShipping = ({ handleAddNew }) => {
    return (
        <div className="text-center pt-[70px] pb-[120px]">
            <img className="mx-auto mb-[35px] w-[95px] h-[115px]" src={icon} alt="" />
            <h2 className="font-inter text-2xl mb-[5px] font-medium leading-8 text-ec-title">
               No Shipping methods configured
            </h2>
            <p className="font-inter text-base mb-6 font-normal text-ec-light-black">
                Your shipping methods will appear here.
            </p>
            <button
                onClick={handleAddNew}
                className="text-ec-primary font-inter text-base h-[45px] px-8 border border-ec-primary rounded-lg hover:text-white hover:bg-ec-primary transition-all 
                        ease-in-out duration-500"
            >
                + New Method
            </button>
        </div>
    );
};

export default EmptyShipping;
